var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-100"},[_c('NuxtLink',{staticStyle:{"z-index":"10"},attrs:{"to":"/"}},[_c('img',{staticClass:"animate__animated animate__bounce animate__delay-4s animate__slow",attrs:{"src":require("./assets/logo.jpg"),"height":"60","alt":""}})]),_c('div',{},[_c('div',{staticClass:"mt-5 px-5"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }